export default __webpack_public_path__ + "de41be9fc62a5c6ca6d0d61efbe4eec0.png";